import React from "react";
import { Doughnut } from "react-chartjs-2";
import { doughnutOptions } from "./_commonSharedChartOptions";
import _ from "lodash";
import { setColor } from "../../../../views/Dashboard/dashboard/ColorPalette";
import { connect } from "react-redux";
import { WidgetNoDataToDisplay, WidgetServerError } from "../../../../components/DashboardWidget/WidgetCommon";
import { uniqueSessionsDataPreview } from "./_previewData";

const widgetMain = {
  Chart: "NUMBER_OF_UNIQUE_SESSIONS_BY_PLATFORM",
  startDate: "05/18/2019%2012:00%20AM",
  endDate: "06/17/2019%2011:59%20PM",
  skillId: "amzn1.ask.skill.37a093eb-f18b-400a-bb88-388f1cc600d5"
};

class UniqueSessionsContentClass extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    const { widgetData, draggable } = this.props;

    return (
      <div>
        <div className="widgetTitle">Unique Sessions</div>
        <div className="widgetBody">
          {draggable ? (
            <WidgetServerError draggable={draggable} />
          ) : widgetData === undefined || draggable ? (
            <WidgetNoDataToDisplay draggable={draggable} />
          ) : (
            <Doughnut
              id={widgetMain.Chart}
              data={{
                labels: widgetData.labels,
                datasets: [
                  {
                    data: widgetData.data,
                    backgroundColor: setColor(widgetData.labels)
                  }
                ]
              }}
              options={doughnutOptions}
            />
          )}
        </div>
      </div>
    );
  }
}

export class UniqueSessionsPreview extends React.Component {
  render() {
    return (
      <div>
        <div className="widgetTitle">Unique Sessions</div>
        <div className="widgetBody">
          <Doughnut
            id={widgetMain.Chart}
            data={uniqueSessionsDataPreview}
            options={_.merge({}, doughnutOptions, {
              legend: {
                labels: {
                  boxWidth: 5,
                  fontSize: 8,
                  padding: 2.5
                }
              },
              plugins: {
                datalabels: {
                  font: {
                    size: 7
                  }
                }
              }
            })}
          />
        </div>
      </div>
    );
  }
}

function mapStateToProps(state, ownProps) {
  return {
    widgetData: state.dashboard.data["UniqueSessionsPerPlatform"]
  };
}

export const UniqueSessionsContent = connect(
  mapStateToProps,
  undefined
)(UniqueSessionsContentClass);
